import React from 'react'

export default function Layout({children, className,isFrontPage, pathname = '/'}) {
  return (
      <main className={isFrontPage ? `main home` : `main ${className}`}>{children}</main>
  )
}
